export function arrowLeftKey(event) {
  event.preventDefault()

  if (!this.selectedItem) return
  const { selectedItem } = this

  const { text, cursorPosition } = selectedItem.getParams()
  if (!text || !cursorPosition) return

  const steps =
    cursorPosition > 1 && text.slice(cursorPosition - 2, cursorPosition) === '/n' ? 2 : 1

  selectedItem.setParams({
    text,
    cursorPosition: cursorPosition - steps,
  })

  this.engine.reRender()
}



// WEBPACK FOOTER //
// ./src/components/ScreenshotEditor/keyboardActions/arrowLeftKey.js